import { inject, provide } from 'vue'

export function createContext(id) {
  const contextId = Symbol(id)
  const provider = value => provide(contextId, value)
  const consumer = fallback => inject(contextId, fallback)

  return [provider, consumer, contextId]
}

export const [TabsProvider, useTabsContext] = createContext('TabsContext')
